import React, { useState, useEffect } from "react";
import { Button } from "@speedoc/design-assets";
import { Link } from "react-router-dom";
import useAppDownloadLink from "../../hooks/useAppDownloadLink";
import { GlobalStore } from "../../stores/global";

const ButtonLink = ({ content, autoHeight }) => {
  const {
    currentCountry: { phoneNumberText, phoneNumberLink }
  } = GlobalStore.useState(c => c);
  const downloadLink = useAppDownloadLink();
  const [buttonLink, setButtonLink] = useState();
  const [buttonText, setButtonText] = useState();

  useEffect(() => {
    if (content.buttonIsPhoneNumber) {
      setButtonLink(phoneNumberLink);
      setButtonText(phoneNumberText);
    } else if (content.buttonIsExternalLink || content.buttonIsInternalLink) {
      setButtonLink(content.buttonLink);
      setButtonText(content.buttonText);
    } else {
      setButtonLink(downloadLink);
      setButtonText(content.buttonText);
    }
  }, [content, downloadLink, phoneNumberLink, phoneNumberText]);

  return (
    <div className="button">
      {content.buttonIsInternalLink ? (
        <Link to={buttonLink || "/"}>
          <Button
            className={`${content.buttonIsPrimary ? "primary" : "secondary"} ${autoHeight ? "autoHeight" : ""} sm`}>
            <span>{buttonText}</span>
          </Button>
        </Link>
      ) : (
        <a href={buttonLink}>
          <Button
            className={`${content.buttonIsPrimary ? "primary" : "secondary"} ${autoHeight ? "autoHeight" : ""} sm`}>
            <span>{buttonText}</span>
          </Button>
        </a>
      )}
    </div>
  );
};

export default ButtonLink;
